import React from 'react'

// components
import Image from 'next/image'
import { CardComponent } from 'components/commons/container/Card.component'
import { Avatar } from '@/components/commons/images/Avatar.component'
import { ImageFit } from 'components/commons/images/ImageFit.component'
import { ButtonComponent } from 'components/commons/buttons/ButtonComponent'
import { MoreOptionsButton } from 'components/commons/buttons/MoreOptionsButton.component'

// utils + services + interfaces
import { IMAGE_PATHS_V2 } from 'shared/consts/imagesPaths'
import { ThemeContext } from 'context/theme/ThemeContext'
import { IBookmarkCard } from 'interfaces'
import {
  calculateFollowers,
  calculateTimePassed,
} from '../../../../shared/utils/pipes'

// styles
import {
  bookmarkCard,
  bookmarkCardHeader,
  bookmarkHeaderUserInfo,
  bookmarkUserAvatar,
  captionContainer,
  bookmarkImageContainer,
  bookmarkImageInteractions,
  bookmarkImageInteraction,
  bookmarkButtonsContainer,
  bookmarkButtonIconContainer,
  bookmarkButtonIcon,
} from 'styles/v2/pages/profile'

export const BookmarkCard: React.FC<IBookmarkCard> = ({
  avatar,
  username,
  caption,
  image,
  interactions,
  date,
}) => {
  const { theme } = React.useContext(ThemeContext)

  const interactionsData = Object.keys(interactions).map((key) => {
    const formatCount = calculateFollowers(interactions[key])
    return {
      icon: key + '_gray_icon.svg',
      alt: key + ' icon',
      count: formatCount.value + formatCount.key,
      key,
    }
  })
  // IMAGE_PATHS_V2.profileDemo + 'avatars/connection_avatar2.png'
  // IMAGE_PATHS_V2.profileDemo + 'bookmarks/bookmark_image_1.png
  return (
    <CardComponent className={[bookmarkCard]}>
      <div className={bookmarkCardHeader}>
        <div className={bookmarkHeaderUserInfo}>
          <div className={bookmarkUserAvatar}>
            <Avatar
              username={username + ' avatar'}
              size={'100%'}
              image={avatar}
            />
          </div>

          <div>
            <span className="fs-16 fs-18-tablet fs cl-text-secondary flh-150 block">
              {username}
            </span>
            <span className="fs-12 fs-14-tablet cl-text-tertiary flh-150 block">
              {calculateTimePassed(date)}
            </span>
          </div>
        </div>
        <MoreOptionsButton />
      </div>

      <div className={captionContainer}>
        <p className="fs-16 cl-text-secondary flh-150 fw-n m-none">{caption}</p>
      </div>

      <div>
        <div className={bookmarkImageContainer}>
          <ImageFit
            src={image}
            alt={username + ' bookmark image'}
            sizes="(max-width: 768px) 100%, 50vw"
          />

          <div className={bookmarkImageInteractions}>
            {interactionsData.map((interaction, index) => (
              <div key={index} className={bookmarkImageInteraction}>
                <div className={bookmarkButtonIconContainer}>
                  <Image
                    fill={true}
                    key={index + interaction.key}
                    className={bookmarkButtonIcon}
                    src={IMAGE_PATHS_V2.icons.commons + interaction.icon}
                    alt={interaction.alt}
                  />
                </div>
                <span className="fs-12 fs-14-tablet fs-16-desktop cl-white-primary flh-100 fw-md m-none">
                  {interaction.count}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className={bookmarkButtonsContainer}>
        {interactionsData.map((interaction, index) => (
          <ButtonComponent key={index} variation="secondary" fullWidth={true}>
            <Image
              key={index + '_interaction_button_icon'}
              className={bookmarkButtonIcon}
              src={
                IMAGE_PATHS_V2.icons.commons +
                theme +
                `/${interaction.key}_icon.svg`
              }
              width={16}
              height={16}
              alt="Bookmark icon"
            />
          </ButtonComponent>
        ))}
      </div>
    </CardComponent>
  )
}
